// extracted by mini-css-extract-plugin
export var label = "_3y-1";
export var reminder = "_3y-0";